// eslint-disable-next-line import/prefer-default-export
export const isModuleLoading = state =>
  state.instruments.management.loading || state.instruments.repairRequests.loading;

export const isModuleLoaded = () => {
  return true;
};
